export default __webpack_public_path__ + "static/media/mao.bac27ac9.mp4";